@import 'styles/mixins';
@import 'styles/variables';

.inputWithActions {
  position: relative;

  .inputActions {
    position: absolute;
    right: 1px;
    top: 11px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: var(--neutral-0);
  }

  button {
    padding: 15px 15px 9px 15px;
    border-left: 1px solid #dfe1e6;
  }
}

.warning {
  margin-top: 10px;
}
